import {useEffect, useRef, useState} from "react";
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import {BottomSheet, SideSheet, Typography} from "@bonprix/design-system";
import {SideSectionAction} from "./SideSectionAction.tsx";

// This component should be used for everything that should be displayed inside a SideSheet or BottomSheet.
// The BottomSheet is only visible for smaller breakpoints. The SideSheet is visible for all other breakpoints.
export default function SideSection() {

    const [open, setOpen] = useState(false);
    const [nodes, setNodes] = useState({title: null, content: null});
    const [bottomSheetSnapPoints, setBottomSheetSnapPoints] = useState([500, 0]);

    const backContent = useRef(null);
    const onCloseCallbackRef = useRef(null);

    useEffect(() => {
        const onOpenSubscription = MessageBroker.subscribe(SideSectionAction.OPEN, onOpen);
        const onCloseSubscription = MessageBroker.subscribe(SideSectionAction.CLOSE, onClose);
        return () => {
            MessageBroker.unsubscribe(onOpenSubscription);
            MessageBroker.unsubscribe(onCloseSubscription);
        };
    }, []);

    const onOpen = ({nodes, snapPoints, back, onCloseCallback, afterOpenedCallback}) => {
        setNodes(nodes);
        if (snapPoints) {
            setBottomSheetSnapPoints(snapPoints);
        }
        if(open) {
            return;
        }
        setOpen(true);
        if (back) {
            backContent.current = back;
        }
        onCloseCallbackRef.current = onCloseCallback;

        if (afterOpenedCallback) {
            afterOpenedCallback();
        }
    };

    const onClose = () => {
        setOpen((prevOpen) => {
            if (!prevOpen) {
                return prevOpen;
            }
            return false;
        });
        MessageBroker.publish(SideSectionAction.CLOSED);
        setBottomSheetSnapPoints([500, 0]);
        backContent.current = null;
        if (onCloseCallbackRef.current) {
            onCloseCallbackRef.current();
        }
    };

    const onBack = () => {
        setNodes(prevNodes => ({...prevNodes, content: backContent.current}));
        backContent.current = null;
    };

    return (<>
        {/*The visibility of the SideSheet and BottomSheet components for the individual breakpoints*/}
        {/*is controlled internally.*/}
        <SideSheet zIndex={1001} isOpen={open} onClose={onClose} onBack={backContent.current ? () => onBack() : null}>
            <SideSheet.Title>{nodes.title}</SideSheet.Title>
            <SideSheet.Content><div className='mb-6'>{nodes.content}</div></SideSheet.Content>
        </SideSheet>
        <BottomSheet
            initialSnap={0}
            zIndex={1001}
            isOpen={open}
            onClose={onClose}
            snapPoints={bottomSheetSnapPoints}
            index={1}
        >
            {nodes.title && <div className="flex flex-row pl-2.5 pr-2.5 pb-5">
                <Typography variant="bonprix-h6" component="div">{nodes.title}</Typography>
            </div>}
            <div id="bottom-sheet-wrapper" className="pl-2.5 pr-2.5 pb-5">
                {nodes.content}
            </div>
        </BottomSheet>
    </>);

}